import { Injectable } from '@angular/core';
import { UserType } from '@app/_models/user-type';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserTypeService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<UserType[]>(`${environment.apiUrl}/api/user/types`);
  }
}
